export class Static {
    static readonly RecMeetingConstants = class {
        static readonly RECUR_DAYS: string = "recurDays";
    };

    static readonly RecMeetingFrequency = class {
        static readonly DAYS: string = "days";
        static readonly WEEK: string = "week";
    };

    static readonly RecMeetingRecurDays = class {
        static readonly Sunday: string = "1";
        static readonly Monday: string = "2";
        static readonly Tuesday: string = "3";
        static readonly Wednesday: string = "4";
        static readonly Thursday: string = "5";
        static readonly Friday: string = "6";
        static readonly Saturday: string = "7";
    };
    static readonly MeetingTimeStatus  = class {
        static readonly LIVE: string = "Live";
        static readonly PAST: string = "Past";
        static readonly UPCOMING: string = "Upcoming";
    };
    static readonly MeetingMode  = class {
        static readonly Hybrid: string = "Hybrid";
        static readonly Online: string = "Online";
        static readonly Offline: string = "Offline";
    };
}
export const RecurringTypeOptions = [
    { label: 'Day', value: 'Day' },
    { label: 'Week', value: 'Week' }
];
